import { Action } from '@ngrx/store';

export enum LoadingActionTypes {
  SetLoading = '[Loading] Set Loading',
  IsLoading = '@digitaix/core/loading/IS_LOADING',
  IsLoaded = '@digitaix/core/loading/IS_LOADED',
}

/**
 * @deprecated use IsLoaded or IsLoading
 */
export class SetLoading implements Action {
  readonly type = LoadingActionTypes.SetLoading;

  constructor(public isLoading: boolean) {}
}

export class IsLoading implements Action {
  public readonly type = LoadingActionTypes.IsLoading;

  constructor(public tracer: string) {}
}

export class IsLoaded implements Action {
  public readonly type = LoadingActionTypes.IsLoaded;

  constructor(public tracer: string) {}
}

export type LoadingActions = SetLoading | IsLoading | IsLoaded;
